<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
import dayjs from "dayjs";
let pinyin = require('js-pinyin');

export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "commondescr",
      key: "id",
      url: {},
      id: "",
      typeId: "",
      items: [
        {label: this.actions == "edit" ? "编辑会议" : "新增会议", type: "header"},
        {
          label: "主题",
          name: "meetingtTitle",
          value: "",
          type: "input",
          width: "400px",
          rules: [{required: true, trigger: "blur"}],
        },
        {
          label: "会议室",
          name: "meetingLocationId",
          value: "",
          type: "select",
          width: "400px",
          dropList: [],
          onChange: this.meetingroom,
          rules: [
            {
              required: true,
              message: "会议室不能为空",
              trigger: "blur",
              type: "number",
            },
          ],
        },
        {
          label: "开始时间",
          name: "meetingStateTime",
          value:
              dayjs().minute() < 15
                  ? dayjs().minute(15).format("YYYY-MM-DD HH:mm")
                  : dayjs().minute() < 30
                      ? dayjs().minute(30).format("YYYY-MM-DD HH:mm")
                      : dayjs().minute() < 45
                          ? dayjs().minute(45).format("YYYY-MM-DD HH:mm")
                          : dayjs().minute(60).format("YYYY-MM-DD HH:mm"),
          type: "datetime",
          format: "yyyy-MM-dd HH:mm",
          timePickerOptions: {
            steps: [1, 15],
          },
          rules: [{required: true, message: "开始时间不能为空", trigger: "blur"}],
          onChange: this.getTime,
        },
        {
          label: "会议时长",
          name: "meetingDuration",
          type: "select",
          width: "400px",
          value: 1,
          dropList: [
            {
              value: 1,
              name: "30分钟",
            },
            {
              value: 2,
              name: "1小时",
            },
            {
              value: 3,
              name: "1.5小时",
            },
            {
              value: 4,
              name: "2小时",
            },
            {
              value: 5,
              name: "2.5小时",
            },
            {
              value: 6,
              name: "3小时",
            },
            {
              value: 7,
              name: "3.5小时",
            },
            {
              value: 8,
              name: "4小时",
            },
            {
              value: 9,
              name: "4.5小时",
            },
            {
              value: 10,
              name: "5小时",
            },
            {
              value: 11,
              name: "5.5小时",
            },
            {
              value: 12,
              name: "6小时",
            },
            {
              value: 13,
              name: "6.5小时",
            },
          ],
          onChange: this.handleChange,
        },
        {
          label: "会议组",
          name: "className",
          value: "",
          type: "multiple",
          width: "400px",
          dropList: [],
          onChange: this.onCouponAlis,
        },
        {
          label: "邀请人",
          name: "userIds",
          value: "",
          type: "multiple",
          filterable: true,
          remote: true,
          remoteMethod: this.searchKeyword,
          loading: false,
          width: "400px",
          dropList: [],
        },

        {
          label: "会议提醒",
          name: "meetingReminder",
          type: "select",
          width: "400px",
          value: 1,
          dropList: [
            {
              value: 1,
              name: "开始前15分钟",
            },
            {
              value: 2,
              name: "开始前20分钟",
            },
            {
              value: 3,
              name: "开始前30分钟",
            },
          ],
          onChange: this.handleChange2,
        },
        {
          label: "签到时间",
          name: "meetingCheckDuration",
          type: "select",
          width: "400px",
          value: 1,
          dropList: [
            {
              value: 1,
              name: "开始前15分钟",
            },
            {
              value: 2,
              name: "开始前20分钟",
            },
            {
              value: 3,
              name: "开始前30分钟",
            },
          ],
          onChange: this.handleChange3,
        },
        {
          label: "备注",
          name: "remark",
          value: "",
          type: "input",
          width: "400px",
        },
      ],
      forms: {
        meetingEndTime: "", //会议结束时间
        reminderTime: "", //会议提醒时间
        meetingSignState: "", //会议签到开始时间
      },
      loadingUser: false,
    };
  },
  props: ["onCancel", "newItem", "actions", "ids"],
  created() {
    if (this.actions == "edit") {
      this.id = this.ids
      this.searchEdit()
    }
    if (this.newItem) {
      this.timeCreated();
    }
    this.meetingClass();
    this.meetingroom();
    this.loaduserData();
  },

  methods: {
    searchKeyword(e) {

      pinyin.setOptions({checkPolyphone: false, charCase: 0});

      if (e !== '') {
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name === "userIds") {
            this.items[index]["loading"] = true;
          }
        }
        let q = {};
        $utils.api.load("/admin/system/user/listAll", q).then((res) => {
          if (res && res.rows) {
            let ll = res.rows;
            let dropList = [];
            for (let index = 0; index < ll.length; index++) {
              const element = ll[index];
              let xx = {};
              xx.value = element.id;
              xx.name = element.nickName;
              dropList.push(xx);
            }
            let pinyinStr = pinyin.getCamelChars(e)
            let list = []
            for (let i = 0; i < dropList.length; i++) {
              let upPinYin = ""
              let fullPinYin = ""
              if (dropList[i].name){
                upPinYin = pinyin.getCamelChars(dropList[i].name);
                fullPinYin = pinyin.getFullChars(dropList[i].name);
              }
              if (fullPinYin.toUpperCase().includes(pinyinStr.toUpperCase()) || upPinYin.toUpperCase().includes(pinyinStr.toUpperCase())){
                list.push(dropList[i])
              }
            }
            console.log(list)

            for (let index = 0; index < this.items.length; index++) {
              const element = this.items[index];
              if (element && element.name === "userIds") {
                this.items[index]["loading"] = false;
                this.items[index]["dropList"] = list;
              }
            }
            console.log(this.items)
          }
        });
      }
    },
    async searchEdit() {
      let res = await $utils.api.load(`/admin/system/meeting/${this.id}`)
      console.log(res);
      if (res.code == 200) {
        let data = res.data
        let q = {
          meetingtTitle: data.meetingtTitle,
          meetingLocationId: data.meetingLocationId,
          meetingStateTime: data.meetingStateTime,
          meetingDuration: Number(data.meetingDuration),
          userIds: data.sysUserList.map((obj) => obj.userId),
          meetingReminder: Number(data.meetingReminder),
          meetingCheckDuration: Number(data.meetingCheckDuration),
          remark: data.remark,
          meetingSignState: data.meetingSignState,
          reminderTime: data.reminderTime,
          meetingEndTime: data.meetingEndTime,
          meetingId: this.id
        }
        this.forms = q
      }

    },
    timeCreated() {
      let state = this.newItem.activeIndexDay + " " + this.newItem.newTime.split("-")[0];
      let end = this.newItem.activeIndexDay + this.newItem.newTime.split("-")[1];
      console.log(state, end);
      this.forms.meetingStateTime = state;
      this.forms.meetingLocationId = this.newItem.meetingListItem.id;
      let stateH = Number(this.newItem.newTime.split("-")[0].split(":")[0]) * 100;
      let stateM = Number(this.newItem.newTime.split("-")[0].split(":")[1]);
      let endH = Number(this.newItem.newTime.split("-")[1].split(":")[0]) * 100;
      let endM = Number(this.newItem.newTime.split("-")[1].split(":")[1]);
      let stateNum = stateH + stateM;
      let endNum = endH + endM;
      let timeDiff = endNum - stateNum + "";
      let m = Number(timeDiff.slice(timeDiff.length - 2, timeDiff.length));
      let h = Number(timeDiff.slice(0, timeDiff.length - 2));
      let endNumS = endNum + "";
      let stateNumS = stateNum + "";
      let meetingLength = null;
      if (
          m != 0 &&
          endNumS.slice(endNumS.length - 2, endNumS.length) <
          stateNumS.slice(stateNumS.length - 2, stateNumS.length)
      ) {
        m = 60 - (100 - m);
      }
      if (h > 0) {
        meetingLength = h * 60 + m;
      } else {
        meetingLength = m;
      }
      if (meetingLength / 30 > 13) {
        this.forms.meetingDuration = 13;
      } else {
        this.forms.meetingDuration = Math.ceil(meetingLength / 30);
      }
    },
    onCouponAlis(val) {
      let combined = val.join(",").split(",");
      let arr2 = [...new Set(combined.map(Number))];
      this.forms.userIds = arr2;
    },
    getTime(val) {
      this.autoCalculateTimes(val);
    },
    handleChange(e) {
      let val = "";
      let arr = this.items[4].dropList;
      arr.map((item) => {
        if (item.value == e) {
          val = item.name;
        }
      });
      let time = this.forms.meetingStateTime;
      if (!time) {
        $utils.toast.success("请选择开始时间");
        return;
      }
      let duration = this.parseDuration(val);
      let formattedTime = this.formatDate(new Date(new Date(time).getTime() + duration));
      this.forms.meetingEndTime = formattedTime;
    },
    handleChange2(e) {
      let val = "";
      let arr = this.items[7].dropList;
      arr.map((item) => {
        if (item.value == e) {
          val = item.name;
        }
      });
      let time = this.forms.meetingStateTime;
      if (!time) {
        $utils.toast.success("请选择开始时间");
        return;
      }
      let duration = this.parseDuration(val);
      let formattedTime = this.formatDate(new Date(new Date(time).getTime() - duration));
      this.forms.reminderTime = formattedTime;
    },
    handleChange3(e) {
      let val = "";
      let arr = this.items[8].dropList;
      arr.map((item) => {
        if (item.value == e) {
          val = item.name;
        }
      });
      let time = this.forms.meetingStateTime;
      if (!time) {
        $utils.toast.success("请选择开始时间");
        return;
      }
      let duration = this.parseDuration(val);
      let formattedTime = this.formatDate(new Date(new Date(time).getTime() - duration));
      this.forms.meetingSignState = formattedTime;
    },
    autoCalculateTimes(time) {
      // 设置默认的时长和提醒
      let defaultDuration = "30分钟"; // 会议时长
      const defaultReminder = "15分钟"; // 会议提醒和签到时间
      let arrD = [];
      if (this.newItem) {
        this.items.forEach((item) => {
          if (item.name == "meetingDuration") {
            arrD = item.dropList;
          }
        });
        arrD.forEach((item) => {
          if (item.value == this.forms.meetingDuration) {
            defaultDuration = item.name;
          }
        });
      }
      // 计算会议时长
      const durationMilliseconds = this.parseDuration(defaultDuration);
      const endTime = new Date(new Date(time).getTime() + durationMilliseconds);
      this.forms.meetingEndTime = this.formatDate(endTime); // 计算得到的会议结束时间
      // 计算会议提醒
      const reminderMilliseconds = this.parseDuration(defaultReminder);
      const reminderTime = new Date(new Date(time).getTime() - reminderMilliseconds);
      this.forms.reminderTime = this.formatDate(reminderTime); // 计算得到的会议提醒时间
      // 计算签到时间
      const signInTime = new Date(new Date(time).getTime() - reminderMilliseconds); // 签到时间与会议提醒相同
      this.forms.meetingSignState = this.formatDate(signInTime); // 计算得到的签到时间
    },
    // 时间格式化函数
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从 0 开始
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    parseDuration(duration) {
      let milliseconds = 0;
      const hoursPattern = /(\d+(\.\d+)?)(小时)/; // 允许小数
      const minutesPattern = /(\d+(\.\d+)?)(分钟)/; // 允许小数
      const hoursMatch = hoursPattern.exec(duration);
      const minutesMatch = minutesPattern.exec(duration);
      if (hoursMatch) {
        milliseconds += parseFloat(hoursMatch[1]) * 60 * 60 * 1000; // 转换为毫秒
      }
      if (minutesMatch) {
        milliseconds += parseFloat(minutesMatch[1]) * 60 * 1000; // 转换为毫秒
      }
      return milliseconds;
    },
    async meetingroom(e) {
      let d = {
        buildingId: e,
      };
      let res = await $utils.api.load("/admin/system/meeting/room/list", d, "get");
      if (res.code == 200) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          let text = element.liableState == 1 ? "(需要审核)" : "";
          xx.value = element.id;
          xx.name = element.meetingName + text;
          xx.children = element.children || [];
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "meetingLocationId") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
    handleSubmit() {
      // this.$Spin.show();
      let q = this.forms;
      if (!q.meetingtTitle) {
        $utils.toast.error("请填写会议主题");
        return
      }
      if (!q.meetingLocationId) {
        $utils.toast.error("请选择会议室");
        return
      }
      if (!q.userIds || q.userIds == []) {
        $utils.toast.error("请选择会议组或邀请人");
        return
      }
      q.meetingSignEnd = q.meetingStateTime;
      this.$refs.form.validate((valid) => {
        this.sloading = true;
        $utils.api
            .load(`/admin/system/meeting`, q, this.actions == "edit" ? "PUT" : "POST")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                this.$emit("onCancel");
                $utils.url.go(0);
              } else {
                this.$Spin.hide();
              }
            })
            .catch((e) => {
              this.sloading = false;
              this.$Spin.hide();
              $utils.toast.error("保存异常" + e.message);
            });
      });
    },
    loaduserData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/user/listAll", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.nickName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "userIds") {
              this.items[index]["dropList"] = (
                  this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    async meetingClass() {
      let d = {};
      let res = await $utils.api.load("/admin/system/meetingClass/seelectList", d, "get");
      if (res.code == 200) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.userIdClass;
          xx.name = element.className;
          xx.children = element.children || [];
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "className") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
  },
};
</script>
